export const newTableHeaderData = [
  { label: "Payment Date", cellWidth: "275px" },
  { label: "Description", cellWidth: "170px" },
  { label: "Amount", cellWidth: "120px" },
  { label: "Payment Type", cellWidth: "180px" },
  { label: "Transaction ID", cellWidth: "330px" },
  { label: "Status", cellWidth: "90px" },
  { label: "", cellWidth: "20px" },
];
export const tokenizeTableHeaderData = [
  { label: "Name", cellWidth: "330px" },
  { label: "Email", cellWidth: "275px" },
  { label: "Phone Number", cellWidth: "170px" },
  { label: "Last 4", cellWidth: "120px" },
  { label: "Account Type", cellWidth: "180px" },
  { label: "Account Status", cellWidth: "90px" },
  { label: "", cellWidth: "20px" },
];

export const newTableBodyData: any[] = [
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Pending",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Failed",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Successful",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Failed",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Successful",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Failed",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Successful",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Pending",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Failed",
    button2: "button2",
  },
  {
    PaymentDate: "date-created",
    productName: "Banziba Cakes",
    amount: "$2,000.00",
    PaymentType: "Debit Card",
    TransactionID: "1234567890",
    status: "Successful",
    button2: "button2",
  },
];
const mappedNewTableBodyData = newTableBodyData.map((item) => ({
  dateCreated: item.PaymentDate,
  productName: item.productName,
  paymentType: item.PaymentType,
  transactionId: item.TransactionID,
  status: item.status,
  amount: item.amount,
  button2: item.button2,
}));

export { mappedNewTableBodyData };
